import { PrepItem } from '@bariendo/lib/payment-status';
import { MRT_ColumnDef, MRT_RowData } from 'mantine-react-table';
import { QUEUE_EMPTY_COLOR, TwoLineCell } from '../../components/QueueCells';
import { PrepChecklist } from './PrepChecklist';

interface PrepRowLike extends MRT_RowData {
  prepItems?: PrepItem[];
}

// Wider for the written-out Questionnaire (BAR-3128: +56 px in the spec).
const PREP_CHECKLIST_SIZE = 266;

/** Questionnaire · RD · NP · Psych, each ticked when done or waived, its date on hover (BAR-3098). */
export function prepChecklistColumn<Row extends PrepRowLike>(): MRT_ColumnDef<Row> {
  return {
    id: 'prepChecklist',
    header: 'Prep checklist',
    size: PREP_CHECKLIST_SIZE,
    enableSorting: false,
    Cell: ({ row }) => {
      const items = row.original?.prepItems;
      return items?.length ? (
        <TwoLineCell primary={<PrepChecklist items={items} />} />
      ) : (
        <TwoLineCell primary={<span style={{ color: QUEUE_EMPTY_COLOR }}>—</span>} />
      );
    },
  };
}
